"use client";

import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import LandingPage from "@/src/pages/landing";

/** `/` — landing when logged out; dashboard when session exists. */
export default function RootHome() {
  const token = useAuthStore((s) => s.accessToken);
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LandingPage />;
}
